export default __webpack_public_path__ + "static/media/ex-pricing.63585a7f.jpg";